export default function FAQSection() {
  const faqs = [
    {
      question: '51暗网的内容来源可靠吗？',
      answer: '51暗网的内容来自多位圈内资深爆料人和一线娱乐记者的供稿，我们拥有严格的内容审核机制，所有爆料均经过交叉验证后才会发布，确保信息的真实性和可靠性。',
    },
    {
      question: '如何在51暗网上找到最新的爆料？',
      answer: '您可以访问51暗网首页查看"最新追踪"板块，或者通过分类页面浏览您感兴趣的爆料类型。我们每天保持高频更新，确保您不错过任何热点。',
    },
    {
      question: '51暗网App在哪里下载？',
      answer: '51暗网App目前可通过官方网站的下载入口获取。我们提供iOS和Android两个版本，下载安装后即可随时随地追踪最新吃瓜黑料。请认准官方渠道下载，谨防假冒。',
    },
    {
      question: '可以向51暗网投稿爆料吗？',
      answer: '当然可以！51暗网欢迎来自各方的真实爆料投稿。您可以通过网站底部的联系方式或关于我们页面的投稿通道提交您的爆料内容。我们会对投稿严格保密，并在核实后发布。',
    },
    {
      question: '51暗网的内容多久更新一次？',
      answer: '51暗网保持每日多次更新的频率。我们的编辑团队全天候关注热点事件，确保在第一时间为您带来最新、最热的吃瓜黑料内容。重大爆料事件我们会进行实时追踪报道。',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium border border-secondary-300 text-secondary-700 bg-secondary-50 mb-4">
              常见问题
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-900">
              你可能想知道
            </h2>
          </div>
          <div className="flex flex-col gap-3">
            {faqs.map((faq, idx) => (
              <details key={idx} className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer">
                <summary className="flex items-center justify-between px-5 py-4 text-sm font-bold text-foreground-900 list-none">
                  {faq.question}
                  <i className="ri-add-line text-foreground-500 group-open:hidden"></i>
                  <i className="ri-subtract-line text-foreground-500 hidden group-open:block"></i>
                </summary>
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}